import { render, staticRenderFns } from "./SubjectsEnrolled.vue?vue&type=template&id=25d05482&"
import script from "./SubjectsEnrolled.vue?vue&type=script&lang=js&"
export * from "./SubjectsEnrolled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports